import store from 'store';

export function onSelectableInputChanged(selectedConfigItemId, groupForItem) {
    Promise.all(groupForItem.oItem_arr.filter((id) => id !== selectedConfigItemId).map((otherItemsInGroup) => {
        return store.dispatch('updateConfigurationItem', {
            id: otherItemsInGroup,
            quantity: 0,
        });
    }));

    store.dispatch('updateConfigurationItem', {
        id: selectedConfigItemId,
        quantity: 1,
    });
}